import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build(
	"/admin/brokers",
	lazy(() => import("./AdminBrokersPage"))
);
